import { authClientFor } from '../../identity/session';
import type { Customer } from '../../identity/api';

/** Every customer of one AUTH environment (pages of 200, at most 2 000), by name. */
export async function allCustomers(target: string): Promise<Customer[]> {
  const out: Customer[] = [];
  for (let page = 1; page <= 10; page++) {
    const r = await authClientFor(target).customers.list({ page, pageSize: 200 });
    out.push(...r.items);
    if (out.length >= r.total || !r.items.length) break;
  }
  return out.sort((a, b) => a.name.localeCompare(b.name));
}

/** `https://acme.nycelogic.com` (or a full URL) → the WorkServer's AUTH identity provider URL. */
export function authenticateUrl(base: string): string {
  const b = base.trim().replace(/\/+$/, '');
  if (!b) return '';
  return /\/api\/authenticate$/i.test(b) ? b : `${b}/api/authenticate`;
}

/** A slug for client names: `wms-<workserver>`. */
export const slug = (s: string) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
